import { makeAutoObservable } from "mobx";
import { Availability } from "./Availability";
export class NewsletterConsentModel {
    constructor(initialValue) {
        this.value = false;
        this.value = initialValue;
        makeAutoObservable(this);
    }
    get availability() {
        return Availability.boolean({
            ConsentRequired: !this.value,
        });
    }
}
